import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {withApollo} from 'react-apollo'
import {notification} from 'antd'
import {UploadOutlined} from '@ant-design/icons'
import FileUploader from 'lib/fileUploader'
import Button from 'components/shared/Button'
import FileUpload from './FileUpload'
import './index.scss'

const signFilestackEventMutation = gql`
  mutation SignFilestackEvent($input: SignFilestackEventInput!) {
    SignFilestackEvent(input: $input) {
      policy
      signature
    }
  }
`

class AssetsUploadQueue extends React.Component {
  static propTypes = {
    client: PropTypes.object.isRequired,
    submitAsset: PropTypes.func.isRequired,
    fileTypes: PropTypes.array,
    multiple: PropTypes.bool,
  }

  static defaultProps = {
    fileTypes: [
      'image/jpeg',
      'application/pdf',
    ],
    multiple: true,
  }

  state = {
    uploads: [],
    isSubmitting: false,
  }

  removeUploader(upload) {
    this.setState({
      uploads: this.state.uploads.filter(u => u !== upload)
    })
  }

  blobIsValid(blob) {
    return this.props.fileTypes.includes(blob.type)
  }

  addUploads(blobs) {
    const uploads = blobs
      .filter(b => this.blobIsValid(b))
      .map(blob =>
        new FileUploader({
          blob,
          onUpdate: this.onUpdate.bind(this),
          fileTypes: this.props.fileTypes,
          getPolicy: this.getPolicy.bind(this),
          onSuccess: async (uploader) => {
            this.props.submitAsset({
              url: uploader.uploadedBlob.url,
              contentType: uploader.uploadedBlob.mimetype,
            })
            .then(() => this.removeUploader(uploader))
            .catch(() => {
              this.cancelUpload(uploader)
              notification.error({
                duration: 8,
                message: 'Opplasting feilet',
                description: `${uploader.inputBlob.name} feilet. Kan være at filtypen ikke er støttet, eller at filen er lastet opp fra før.`,
              })
            })
          },
        })
      )

    this.setState({uploads: [...this.state.uploads, ...uploads]})
  }

  cancelUpload(uploader) {
    uploader.removeUpload()
    this.removeUploader(uploader)
  }

  onUpdate() {
    this.forceUpdate()
  }

  handleFileChange(event) {
    const files = event.target.files
    if (files && files.length) {
      this.addUploads([...files])
    }
  }

  selectFiles() {
    this.refs.fileInput.click()
  }

  getPolicy(options) {
    return this.props.client.mutate({
      mutation: signFilestackEventMutation,
      variables: {
        input: {
          options: JSON.stringify(options),
        }
      }
    }).then((res) => res.data.SignFilestackEvent)
  }

  render() {
    const acceptedFileTypes = this.props.fileTypes.join(',')

    return (
      <div className="assets-upload-queue">
        <div className="uploads">
          {this.state.uploads.map((upload, i) => (
            <FileUpload
              key={i}
              uploader={upload}
              onCancel={this.cancelUpload.bind(this)}
            />
          ))}
        </div>

        <div className="actions">
          <>
            <Button
              secondary
              type="action"
              icon={<UploadOutlined />}
              onClick={this.selectFiles.bind(this)}
            >
              Velg filer fra datamaskinen din
            </Button>
            <input
              className="hidden-file-input"
              ref="fileInput"
              type="file"
              onChange={this.handleFileChange.bind(this)}
              multiple={this.props.multiple}
              accept={acceptedFileTypes}
            />
          </>
        </div>
      </div>
    )
  }
}

export default withApollo(AssetsUploadQueue)
